import { render, staticRenderFns } from "./DefaultRadioButton.vue?vue&type=template&id=df45e884&scoped=true"
import script from "./DefaultRadioButton.vue?vue&type=script&lang=js"
export * from "./DefaultRadioButton.vue?vue&type=script&lang=js"
import style0 from "./DefaultRadioButton.vue?vue&type=style&index=0&id=df45e884&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df45e884",
  null
  
)

export default component.exports